import React from 'react';
import '../styles/Journal.scss';

const Journal = () => {
    const articles = [
        { date: "Oct 12, 2090", title: "Life on Mars: A Resident's Guide", desc: "Adaptation to red dust and lower gravity." },
        { date: "Sept 28, 2090", title: "Zero-G Sports League Finals", desc: "The Titans vs. The Comets: Match Preview." },
        { date: "Aug 15, 2090", title: "Dining at the Edge of Space", desc: "Chef Aris on his new orbital menu." }
    ];

    return (
        <section className="journal">
            <div className="container">
                <h2 className="section-title">From the <span>Void</span></h2>
                <div className="journal-grid">
                    {articles.map((article, i) => (
                        <div key={i} className="journal-card">
                            <span className="date">{article.date}</span>
                            <h3>{article.title}</h3>
                            <p>{article.desc}</p>
                            <button className="read-more">Read Article &rarr;</button>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Journal;
